import eventbus from "../eventbus";
import { getStorage } from "./storage";
import logger from "./logger";

const updateAppVersion = (version) => {
    const current_version = getStorage("app-version");

    if (current_version !== version) {
        eventbus.emit("app-requires-update", true);
        logger.info(
            `App update available! \nCurrent version: ${current_version} \nAvailable version: ${version}`,
        );
    }
};

export default updateAppVersion;
